var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IconBtn',{attrs:{"icon":"mdi-sync","title":"Recreate","loading":_vm.loading},on:{"click":function($event){return _vm.recreate()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }